// extracted by mini-css-extract-plugin
module.exports = {"TextModule":"TextModule_TextModule__Wl1pz"};